/*
 * サイトをまたいで使えるスケルトンローダーの最小部品。
 * 表示するカードや一覧の構造・余白は、各機能側のJSとSCSSで定義する。
 */
(function (window) {
  function block(className = "", tagName = "span") {
    const classes = ["c_skeleton", className].filter(Boolean).join(" ");
    return `<${tagName} class="${classes}"></${tagName}>`;
  }

  function line(size = "long") {
    return block(`c_skeleton_line -${size}`);
  }

  function meta() {
    return block("c_skeleton_meta");
  }

  function tag() {
    return block("c_skeleton_tag");
  }

  function image({ className = "", tagName = "span" } = {}) {
    return block(["c_skeleton_image", className].filter(Boolean).join(" "), tagName);
  }

  function repeat(count, renderer) {
    const length = Math.max(0, Number.parseInt(count, 10) || 0);
    return Array.from({ length }, (_, index) => renderer(index)).join("");
  }

  // ほかの機能JSや別サイトでも使えるよう、名前空間を一つだけ公開する。
  window.SkeletonLoader = Object.freeze({
    block,
    line,
    meta,
    tag,
    image,
    repeat,
  });
})(window);
